<template>
  <div class="Login">
    <h1>This is the Login</h1>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Login',
  components: {

  }
}
</script>